import { render, staticRenderFns } from "./num.vue?vue&type=template&id=68ca76ea&scoped=true"
import script from "./num.vue?vue&type=script&lang=js"
export * from "./num.vue?vue&type=script&lang=js"
import style0 from "./num.vue?vue&type=style&index=0&id=68ca76ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ca76ea",
  null
  
)

export default component.exports